import { ConnectedUser } from "@/dto";
import Axios from "axios";

export default {
  /**
   * récupère l'utilisateur connecté
   * @returns renvoie l'objet ou null.
   */
  async getConnectedUser() {
    var response = await Axios.get("api/user");
    if (response) {
      return new ConnectedUser(response);
    } else {
      return null;
    }
  },
};
